import React from 'react'
import PropTypes from 'prop-types'
import { Chip } from 'client/common/components/chip/Chip'
import { CrossIcon } from 'chemistry'

const ActiveFiltersChips = ({ collection, onRemove }) => {
  return Object.entries(collection).map(([key, values]) =>
    values.map(value => (
      <Chip
        as='button'
        key={`${key}-${value.value}`}
        onClick={() =>
          onRemove({
            title: key,
            item: {
              checked: false,
              value
            },
            filterPosition: 'side'
          })
        }
      >
        {value.label}
        <CrossIcon lineHeight='inherit' cursor='pointer' />
      </Chip>
    ))
  )
}

ActiveFiltersChips.propTypes = {
  collection: PropTypes.array,
  onRemove: PropTypes.func
}

export default ActiveFiltersChips
